import type { TrafficScheme } from '$lib/components/traffic/types';
import * as m from '$paraglide/messages';

const trafficEventLabelKey: Record<TrafficScheme, () => string> = {
	carAccident: m.traffic_event__car_accident,
	carIncident: m.traffic_event__car_incident,
	carDangerous: m.traffic_event__car_dangerous,
	laneClosed: m.traffic_event__lane_closed,
	constructionCone: m.traffic_event__construction_cone,
	weatherHail: m.traffic_event__weather_hail,
};

export function trafficEvent(type: TrafficScheme): string {
	return trafficEventLabelKey[type]();
}
